import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{staticClass:"accent--text fill-height text-center mx-auto",attrs:{"max-width":"100pt","max-height":"60pt","min-height":"60pt","loading":_vm.loading,"rounded":"xl"}},[_c(VCardTitle,{staticClass:"text-h5 justify-center"},[_vm._v("\n    "+_vm._s(_vm.displayValue)+"\n  ")]),_c(VCardSubtitle,{staticClass:"text-h7"},[_vm._v(" "+_vm._s(_vm.statName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }